<template>
  <section class="rt-footer__infos">
        <div class="rt-container">
            <span class="rt-footer__infos-info">Partita IVA 01386030488</span>
            <div class="rt-footer__logo">
                <picture>
                    <source srcset="https://www.regione.toscana.it/o/regione-toscana-theme/images/logo-regione-footer-mobile.png, https://www.regione.toscana.it/o/regione-toscana-theme/images/logo-regione-footer-mobile@2x.png 2x" media="(max-width: 767px)">
                    <img alt="Logo Regione Toscana" src="https://www.regione.toscana.it/o/regione-toscana-theme/images/logo-regione-footer.png" srcset="https://www.regione.toscana.it/o/regione-toscana-theme/images/logo-regione-footer@2x.png 2x">
                </picture>
            </div>
        </div>
    </section>
</template>

<script>
export default {
  name: "RTFooter"
};
</script>

<style>
.hide {
  display: none;
}

.rt-footer__infos-info {
    font-size: .875rem;
}

.rt-footer__infos-info {
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-size: .6875rem;
    color: #555;
}

.rt-footer__infos .rt-container {
	padding-left: 1em;
	background-color: #FFFFFF;
	border-top: solid 1px #CCC;
	margin-top: 5em;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.rt-footer__logo {
    height: 74px;
}

.rt-footer__logo img {
    height: 74px;
}
</style>
